import React, { useEffect, useState } from "react";
import { ProductService } from "services/ProductService";
import styles from './AssociationProductItem.module.scss';
import imageFile from "../../../assets/images/default_product.png";
import i18n from "i18n";

export const AssociationProductItem = (props) => {
    const [imageError, setImageError] = useState(false);

    return (
        <>
            {props.product && (
                <div className={styles["association-product-item"]}>
                    <img src={!props.product?.image || imageError ? imageFile : props.product.image}
                        onError={() => { setImageError(true) }} />
                    <div className={styles["association-product-data"]}>
                        <div>
                            {props.product?.name}
                        </div>
                        <div className={styles["association-product-sku"]}>
                            {i18n.t("sku")} {props.product?.sku}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AssociationProductItem;